import React from 'react';
import { Box, Text } from '@fullstory/components';
import { EngagementMapsDetailsRow } from '../EngagementMapsDetailsRow';
import { FormattedMessage } from 'react-intl';

export interface DeviceRowProps {
  device: string;
}

export const DeviceRow: React.FC<DeviceRowProps> = ({ device }) => (
  <EngagementMapsDetailsRow
    data-component="DeviceRow"
    icon={{ name: 'device-desktop' }}
    label={{ body: 'Device:' }}
    value={{ body: device }}
    tooltipContent={
      <Box>
        <Text appearance="bodySmall" color="inherit">
          <FormattedMessage
            defaultMessage="The device for which the data is restricted to, derived from the current session."
            id="pvcZmJ"
          />
        </Text>
      </Box>
    }
  />
);
